import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element';
import { InnerBlocks, InspectorControls, BlockControls } from '@wordpress/block-editor';
import { CheckboxControl, PanelBody, Toolbar } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import useBlockNavigator from './use-block-navigator';

function NavigationMenu(_ref) {
  var attributes = _ref.attributes,
      setAttributes = _ref.setAttributes,
      clientId = _ref.clientId;

  var _useBlockNavigator = useBlockNavigator(clientId),
      navigatorToolbarButton = _useBlockNavigator.navigatorToolbarButton,
      navigatorModal = _useBlockNavigator.navigatorModal;

  return createElement(Fragment, null, createElement(BlockControls, null, createElement(Toolbar, null, navigatorToolbarButton)), navigatorModal, createElement(InspectorControls, null, createElement(PanelBody, {
    title: __('Menu Settings')
  }, createElement(CheckboxControl, {
    value: attributes.automaticallyAdd,
    onChange: function onChange(automaticallyAdd) {
      setAttributes({
        automaticallyAdd: automaticallyAdd
      });
    },
    label: __('Automatically add new pages'),
    help: __('Automatically add new top level pages to this menu.')
  }))), createElement("div", {
    className: "wp-block-navigation-menu"
  }, createElement(InnerBlocks, {
    allowedBlocks: ['core/navigation-menu-item'],
    renderAppender: InnerBlocks.ButtonBlockAppender
  })));
}

export default NavigationMenu;
//# sourceMappingURL=edit.js.map